// 2026-09-17: thêm a11y (button/listbox/option, aria-selected), bàn phím (↑↓ Home End Enter Space Esc Tab),
// đánh dấu lựa chọn hiện tại; bỏ style inline left:90px (CSS nằm ở gwc-collections.css). Bản cũ: backup-cards-2026-09-17/
if (!customElements.get('bb-custom-select')) {
  customElements.define(
    'bb-custom-select',
    class BbCustomSelect extends HTMLElement {
      connectedCallback() {
        this.render();
      }

      render() {
        const optionsAttr = this.getAttribute('options');
        const selectedValue = this.getAttribute('selected');
        let options = [];
        try {
          options = JSON.parse(optionsAttr);
        } catch (e) {
          console.error('Invalid options JSON:', optionsAttr);
        }
        const current = options.find((opt) => opt[0] === selectedValue) || options[0] || ['', ''];
        const listId = `${this.getAttribute('id') || 'bb-select'}-list`;
        const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

        this.innerHTML = `
          <div class="select-wrapper select">
            <div class="selected custom-select active" role="button" tabindex="0" aria-haspopup="listbox" aria-expanded="false" aria-controls="${listId}" aria-label="Sort by: ${esc(current[1])}">${esc(current[1])}</div>
            <ul class="options select-options" id="${listId}" role="listbox" aria-label="Sort by">
              ${options
                .map(
                  (opt) =>
                    `<li role="option" tabindex="-1" data-value="${esc(opt[0])}" aria-selected="${opt[0] === current[0]}">${esc(opt[1])}</li>`
                )
                .join('')}
            </ul>
          </div>
        `;
        this.addEvents();
      }

      addEvents() {
        const wrapper = this.querySelector('.select-wrapper');
        const trigger = this.querySelector('.selected');
        const items = [...this.querySelectorAll('.options li')];
        const name = this.getAttribute('name');
        const id = this.getAttribute('id');

        const open = (focusSelected) => {
          wrapper.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
          if (focusSelected) (items.find((li) => li.getAttribute('aria-selected') === 'true') || items[0])?.focus();
        };
        const close = (refocus) => {
          wrapper.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
          if (refocus) trigger.focus();
        };
        const choose = (li) => {
          const value = li.getAttribute('data-value');
          const label = li.textContent;
          items.forEach((el) => el.setAttribute('aria-selected', String(el === li)));
          trigger.textContent = label;
          trigger.setAttribute('aria-label', `Sort by: ${label}`);
          close(true);
          this.value = value;
          this.text = label;
          this.dispatchEvent(new CustomEvent('change', { detail: { id, name, value, label }, bubbles: true }));
        };

        trigger.addEventListener('click', () => (wrapper.classList.contains('open') ? close() : open()));
        trigger.addEventListener('keydown', (e) => {
          if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(e.key)) {
            e.preventDefault();
            open(true);
          } else if (e.key === 'Escape') close();
        });
        items.forEach((li, i) => {
          li.addEventListener('click', () => choose(li));
          li.addEventListener('keydown', (e) => {
            const move = { ArrowDown: i + 1, ArrowUp: i - 1, Home: 0, End: items.length - 1 }[e.key];
            if (move !== undefined) {
              e.preventDefault();
              items[(move + items.length) % items.length].focus();
            } else if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              choose(li);
            } else if (e.key === 'Escape') {
              e.preventDefault();
              close(true);
            } else if (e.key === 'Tab') close();
          });
        });
        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) close();
        });
      }
    }
  );
}
